import { createAsyncThunk } from '@reduxjs/toolkit';

import { createClientGraphQL } from '../../graphql/createClientGraphQL';
import { ResponseQueryAllClientsAdditionalInfo, QUERY_ALL_CLIENTS_ADDITIONAL_INFO } from '../../queries/list';
import { selectorProjectId } from '../selectors/general';

export const thunkAllClientsAdditionalInfo = createAsyncThunk<ResponseQueryAllClientsAdditionalInfo['getAllAdditionalInfoByProject'], void>(
  'otherInfo/list',
  async (_, thunkAPI) => {
    try {
      // @ts-ignore
      const project_id = selectorProjectId(thunkAPI.getState());
      const GraphQL = createClientGraphQL();
      const response = await GraphQL.query({ query: QUERY_ALL_CLIENTS_ADDITIONAL_INFO, variables: { project_id } });
      const { getAllAdditionalInfoByProject } = response.data as ResponseQueryAllClientsAdditionalInfo;
      if (getAllAdditionalInfoByProject) {
        // ? Runtime mapping check kept commented by design.
        // ? checkOtherInfoLabels(getAllAdditionalInfoByProject, translationsIT.otherInfoSections);

        // Keep only fields not hidden (disabled on Client Info Manager) on this project
        // from a specific Client Info Manager tab (tab) currently commented
        // persisted under client.additionalInfo (path),
        // not already handled by dedicated sections tags/actions (name) to avoid duplicates
        // and filterable in the drawer (select-like inputs)
        const otherInfo = getAllAdditionalInfoByProject?.filter(
          (data) =>
            // uncomment next line if u need custom filters only
            // data.project_id === project_id &&
            !(data.hiddenProjects ?? []).includes(project_id) &&
            !data.disabled &&
            //['Generale', 'Altre Informazioni'].includes(data.tab) &&
            data.path === 'additionalInfo' &&
            !['tag', 'tag2', 'actions'].includes(data.name) &&
            ['radio', 'select', 'selectMultiple'].includes(data.type),
        );
        return thunkAPI.fulfillWithValue(otherInfo);
      }
      return thunkAPI.fulfillWithValue([]);
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue('Failed to load all clientsAdditionalInfo');
    }
  },
);
